/* Artiza Atelier — product page: colour-tinted option pills + live bulk pricing */
(function () {
  var info = document.querySelector('.product__info-container, product-info');
  if (!info) return;

  /* ---------- 1. Colour pills ---------- */
  var COLORS = {
    wine:'#7B1E3A', nblue:'#1F2A5A', navy:'#1F2A5A', navyblue:'#1F2A5A', pista:'#93C572', bgreen:'#1E5631', bottlegreen:'#1E5631',
    mehendi:'#7A8B2E', mehndi:'#7A8B2E', lavender:'#9C88C9', rani:'#D6246E', ranipink:'#D6246E', black:'#1A1A1A', maroon:'#800020',
    pitch:'#F4A88A', peach:'#F4A88A', fone:'#C9A27E', fawn:'#C9A27E', cream:'#E8DCC0', gray:'#8A8D91', grey:'#8A8D91',
    mustard:'#D4A017', gajri:'#F26B3A', carrot:'#F26B3A', pink:'#F49AC2', babypink:'#F7B8D0', cgreen:'#2FA58A', seagreen:'#2E8B57',
    gold:'#C9A54C', golden:'#C9A54C', silver:'#B8B8B8', white:'#FFFFFF', offwhite:'#F2EDE3', red:'#C0262D', yellow:'#F2C230',
    orange:'#F28C28', purple:'#6B3FA0', blue:'#2F6FC9', skyblue:'#7EC8E3', green:'#2E8B57', parrot:'#5DBB46', parrotgreen:'#5DBB46',
    brown:'#7B4A2D', coffee:'#6F4E37', beige:'#D9C3A0', skin:'#E8C1A0', rust:'#B7472A', teal:'#2A8C8C', magenta:'#C21E7B',
    copper:'#B87333', turquoise:'#30C5C0', firozi:'#30C5C0', onion:'#C77D8E', onionpink:'#C77D8E', lemon:'#E8E05A', olive:'#6B7B2F',
    mint:'#98D7C2', rose:'#E7849A', ivory:'#F4EFE1', grape:'#5B2A5E', violet:'#7F3FBF'
  };
  function hexToRgb(h){ h=h.replace('#',''); return [parseInt(h.substr(0,2),16),parseInt(h.substr(2,2),16),parseInt(h.substr(4,2),16)]; }
  function mix(rgb,w){ return 'rgb('+rgb.map(function(c){return Math.round(c*w+255*(1-w));}).join(',')+')'; }
  function lum(rgb){ return (0.299*rgb[0]+0.587*rgb[1]+0.114*rgb[2])/255; }
  function keyOf(name){
    var k = (name||'').toLowerCase().replace(/[^a-z]/g,'');
    if (COLORS[k]) return k;
    // "lavender 2", "light pink" etc. -> try the last known word
    var words = (name||'').toLowerCase().split(/[^a-z]+/).filter(Boolean);
    for (var i = words.length - 1; i >= 0; i--) if (COLORS[words[i]]) return words[i];
    return null;
  }
  function tintPills(){
    document.querySelectorAll('fieldset').forEach(function(fs){
      var lg = fs.querySelector('legend');
      if (!lg || !/colou?r|shade/i.test(lg.textContent)) return;
      fs.querySelectorAll('input[type="radio"]').forEach(function(inp){
        var lab = fs.querySelector('label[for="'+inp.id+'"]');
        if (!lab) return;
        // Leave Shopify's round image/colour swatches untouched
        if (lab.classList.contains('swatch-input__label') || lab.querySelector('.swatch') || inp.classList.contains('swatch-input__input')) {
          lab.classList.remove('at-swatch'); return;
        }
        var k = keyOf(inp.value);
        if (!k) return;
        var rgb = hexToRgb(COLORS[k]);
        lab.classList.add('at-swatch');
        lab.style.setProperty('--sw', COLORS[k]);
        lab.style.setProperty('--sw-bg', mix(rgb, k==='white'||k==='offwhite'||k==='ivory'||k==='cream' ? 1 : 0.2));
        lab.style.setProperty('--sw-bd', mix(rgb, 0.55));
        lab.style.setProperty('--sw-fg', lum(rgb) > 0.6 ? '#26362A' : '#FFFFFF');
      });
    });
  }

  /* ---------- 2. Live bulk pricing ---------- */
  var TIERS = [{min:31,off:15},{min:21,off:10},{min:10,off:7}];
  function tierFor(q){ for (var i=0;i<TIERS.length;i++) if (q>=TIERS[i].min) return TIERS[i]; return null; }
  function fmt(cents){ return 'Rs. ' + (cents/100).toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2}); }

  var product = null;
  var handle = (location.pathname.match(/\/products\/([^\/?#]+)/)||[])[1];
  if (handle) fetch('/products/' + handle + '.js').then(function(r){return r.json();}).then(function(p){ product = p; update(); }).catch(function(){});

  function currentVariant(){
    if (!product) return null;
    var idEl = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var id = idEl ? parseInt(idEl.value, 10) : null;
    var v = null;
    product.variants.forEach(function(x){ if (x.id === id) v = x; });
    return v || product.variants[0];
  }
  function qtyInput(){ return info.querySelector('input[name="quantity"]') || document.querySelector('.product-form__quantity input[name="quantity"], input.quantity__input'); }

  function update(){
    var v = currentVariant(); if (!v) return;
    var qi = qtyInput(); var q = qi ? Math.max(1, parseInt(qi.value,10)||1) : 1;
    var t = tierFor(q);
    var unit = t ? Math.round(v.price * (100 - t.off) / 100) : v.price;

    // main price line
    var last = info.querySelector('.price .price-item--last');
    if (last) {
      if (last.textContent !== fmt(unit)) last.textContent = fmt(unit);
      var chip = info.querySelector('.at-bulk-chip');
      if (t) {
        if (!chip) { chip = document.createElement('span'); chip.className = 'at-bulk-chip'; last.parentNode.insertBefore(chip, last.nextSibling); }
        if (chip.textContent !== t.off + '% bulk off') chip.textContent = t.off + '% bulk off';
      } else if (chip) chip.remove();
    }

    // summary under the price
    var priceBox = info.querySelector('.price');
    if (priceBox) {
      var sum = info.querySelector('.at-bulk-sum');
      if (!sum) { sum = document.createElement('div'); sum.className = 'at-bulk-sum'; sum.setAttribute('aria-live','polite'); priceBox.parentNode.insertBefore(sum, priceBox.nextSibling); }
      var total = unit * q, html;
      if (t) {
        var saved = (v.price - unit) * q;
        html = '<b>' + fmt(unit) + '</b> per pc × ' + q + ' = <b>' + fmt(total) + '</b><span class="at-bulk-save">You save ' + fmt(saved) + '</span>';
      } else {
        var need = 10 - q;
        html = 'Total for ' + q + ' pc' + (q>1?'s':'') + ': <b>' + fmt(total) + '</b><span class="at-bulk-hint">Add ' + need + ' more for 7% off</span>';
      }
      if (sum.getAttribute('data-k') !== html) { sum.setAttribute('data-k', html); sum.innerHTML = html; }
    }

    // highlight the matching "Buy more, save more" row and refresh its per-pc prices for this variant
    document.querySelectorAll('.qb-option').forEach(function(o){
      var off = parseInt(o.getAttribute('data-discount'),10);
      o.classList.toggle('qb-selected', !!t && t.off === off);
      var pp = o.querySelector('.qb-price');
      var ptxt = fmt(Math.round(v.price * (100 - off) / 100)) + ' per pc';
      if (pp && pp.textContent !== ptxt) pp.textContent = ptxt;
    });
    var note = document.getElementById('qb-note'); if (note) note.style.display = 'none';
  }

  /* ---------- wiring ---------- */
  function run(){ tintPills(); update(); }
  document.addEventListener('change', function(e){ if (e.target && (e.target.name === 'quantity' || e.target.type === 'radio' || e.target.name === 'id')) setTimeout(run, 30); }, true);
  document.addEventListener('input', function(e){ if (e.target && e.target.name === 'quantity') update(); }, true);
  document.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('.quantity__button, .qb-option')) setTimeout(update, 40); }, true);
  // Dawn re-renders the price and option pills after a variant change
  var busy = false;
  new MutationObserver(function(){ if (busy) return; busy = true; setTimeout(function(){ run(); busy = false; }, 60); })
    .observe(info, { childList: true, subtree: true });
  run();
})();
